(function(){
/* Apparition douce des sections sous la fiche. Rien dans le haut de la fiche (section principale, petit carrousel
   d'avis, bandes qui défilent) : seuls les blocs des sections suivantes apparaissent, et ils démarrent avant d'entrer
   à l'écran pour qu'on ne voie jamais de zone vide en descendant. */
if (!('IntersectionObserver' in window)) return;
if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
var groups = [
  '.kls-title', '.kls-sub', '.kls-rating', '.kls-badges', '.kls-cta', '.klg__cta',
  '.kld__head', '.kld__cta',
  '.klpt__item', '.klcp__col', '.kls-review', '.klf__list', '.klg'
];
var sel = groups.join(',');
function mark(){
  var fold = window.innerHeight;
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('kl-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px 20% 0px', threshold: 0 });
  document.querySelectorAll(sel).forEach(function(el){
    if (el.dataset.klRv) return;
    el.dataset.klRv = '1';
    if (el.closest('.klp, .kls-reviews--carousel, .kld__row')) return; /* haut de fiche et carrousels : jamais cachés */
    if (el.getBoundingClientRect().top < fold * 1.2) return; /* déjà visible ou presque : on ne cache rien */
    /* léger décalage entre éléments frères (cartes côte à côte) */
    var i = 0, s = el.previousElementSibling;
    while (s && i < 3){ if (s.matches && s.matches(sel)) i++; s = s.previousElementSibling; }
    el.style.setProperty('--kl-d', (i * 0.06) + 's');
    el.classList.add('kl-rv');
    io.observe(el);
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mark); else mark();
document.addEventListener('shopify:section:load', mark);
})();
